module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2-2"
  }, [_c('i', [_vm._v("contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter01"
    }
  }, [_c('i', [_vm._v("the")]), _vm._v(" great gatsby party "), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/toc01.jpg",
      "width": "24"
    }
  }), _vm._v(" 1974")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02"
    }
  }, [_vm._v("use everything "), _c('i', [_vm._v("in")]), _vm._v(" your arsenal "), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/toc02.jpg",
      "width": "36"
    }
  }), _vm._v(" 1980")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("lucky "), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/toc03.jpg",
      "width": "32"
    }
  }), _vm._v(" 1985")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("the")]), _vm._v(" guest room "), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/toc04.jpg",
      "width": "32"
    }
  }), _vm._v(" 1986")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("a")]), _vm._v(" shift "), _c('i', [_vm._v("in the")]), _vm._v(" weather "), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/toc05.jpg",
      "width": "40"
    }
  }), _vm._v(" 1990")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("trees "), _c('i', [_vm._v("from")]), _vm._v(" heaven "), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/toc06.jpg",
      "width": "24"
    }
  }), _vm._v(" 2003")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("opportunity cost "), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/toc07.jpg",
      "width": "29"
    }
  }), _vm._v(" 2006")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("the")]), _vm._v(" vagaries "), _c('i', [_vm._v("of")]), _vm._v(" love "), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/toc08.jpg",
      "width": "32"
    }
  }), _vm._v(" 2007")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("in the")]), _vm._v(" hermitage "), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "height": "15",
      "src": "images/toc09.jpg",
      "width": "39"
    }
  }), _vm._v(" 2010")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("in the")]), _vm._v(" museum "), _c('i', [_vm._v("of")]), _vm._v(" your life "), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/toc10.jpg",
      "width": "32"
    }
  }), _vm._v(" 2011")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("garden "), _c('i', [_vm._v("for the")]), _vm._v(" blind "), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/toc11.jpg",
      "width": "27"
    }
  }), _vm._v(" 2014")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Acknowledgment",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("acknowledgments")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-772d7f8a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Contents.vue
// module id = 72
// module chunks = 0